import { isMonitorAgentLogsCollectEnabled } from '../isMonitorAgentLogsCollectEnabled';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';

export function useAgentLogCollectEnabled() {
  const { MONITOR_AGENT_LOGS_COLLECT_TEST_CASE } = featureFlagConstants;

  const { treatments, isReady } = useFeatureFlag([
    MONITOR_AGENT_LOGS_COLLECT_TEST_CASE
  ]);

  const isEnabled = isMonitorAgentLogsCollectEnabled(
    treatments[MONITOR_AGENT_LOGS_COLLECT_TEST_CASE]?.treatment
  );

  return { isEnabled, isReady };
}
